import { Link } from 'react-router';
import { useIntl } from '@/react-intl';
import { SimulationSpecErrorsError } from '../data/ModuleStudioRepository';
import { simulationIssueLabel, SIMULATION_DELIVERY_ID } from './simulationDelivery';

const errorKey = (error: unknown): string => {
  const response=(error as {response?:{data?:{code?:string}}}|null)?.response;
  switch(response?.data?.code ?? (error instanceof Error ? error.message : undefined)) {
    case 'studio.command.stale_version':return 'moduleStudio.simRefresh.versionChanged';
    case 'simulation.retirement_required':
    case 'simulation.retirement_pending':
    case 'simulation.restore_expired':
    case 'simulation.not_stale':return 'moduleStudio.simRefresh.retirementBlocked';
    case 'simulation.prototype_unavailable':return 'moduleStudio.simulation.dataSource.unavailable';
    case 'simulation.conflict':return 'moduleStudio.simulation.conflict';
    case 'simulation.limit':return 'moduleStudio.simulation.error.limit';
    case 'simulation.too_large':return 'moduleStudio.simulation.error.too_large';
    case 'simulation.spec_errors':return 'moduleStudio.simulation.error.spec_errors';
    default:return 'moduleStudio.simulation.error.invalid';
  }
};
/** R1 : un refus `simulation.spec_errors` dit QUELLES erreurs de structure empêchent la simulation et comment les corriger, jamais le message générique. */
function SpecErrors({error,designPath}:{error:SimulationSpecErrorsError;designPath?:string}) {
  const intl=useIntl(),t=(id:string,values?:Record<string,string|number>)=>intl.formatMessage({id},values);
  return <>
    <p className="font-medium">{t(SIMULATION_DELIVERY_ID.specErrorsTitle,{count:error.issues.length})}</p>
    <ul className="my-2 list-disc space-y-1 ps-5">{error.issues.map((issue,index)=><li key={index} className="break-words">{simulationIssueLabel(t,issue)}{' '}<code dir="ltr" className="break-all">{issue.path}</code></li>)}</ul>
    <p>{t(SIMULATION_DELIVERY_ID.specErrorsHelp)}</p>
    {designPath ? <Link className="ui-focus-ring underline" to={designPath}>{t('moduleStudio.simulation.specErrors.fix')}</Link> : null}
  </>;
}
export default function SimulationErrorPanel({error,designPath,onReload}:{error:unknown;designPath?:string;onReload?:()=>void}) {
  const intl=useIntl();
  if(!error)return null;
  return <div role="alert" className="rounded-md border border-danger-solid bg-danger-subtle p-3 text-danger-text">
    {error instanceof SimulationSpecErrorsError ? <SpecErrors error={error} designPath={designPath}/> : <p>{intl.formatMessage({id:errorKey(error)})}</p>}
    {onReload ? <button type="button" className="ui-focus-ring pointer-coarse:min-h-11 underline" onClick={onReload}>{intl.formatMessage({id:'moduleStudio.simulation.reload'})}</button> : null}
  </div>;
}
